import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { ApiError } from 'src/app/interfaces/api';
import { IStrapiDocument, VerifiedEmailPage } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { UserService } from 'src/app/services/user.service';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';

@Component({
    selector: 'app-email-verified',
    templateUrl: './email-verified.component.html',
    styleUrls: ['./email-verified.component.scss'],
    imports: [
        NgIf,
        RouterLink,
        NgSwitch,
        NgSwitchCase,
    ],
})
export class EmailVerifiedComponent extends PageComponent implements OnInit {
  public override pageData: VerifiedEmailPage = <VerifiedEmailPage>{};

  private cdr = inject(ChangeDetectorRef);

  public success = false;

  public email: string | null = '';

  public failureReason = '';

  public resent = false;

  public resendError = false;

  public notFoundError = false;

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,

    public override readonly strapi: StrapiService,
    private readonly route: ActivatedRoute,
    private readonly user: UserService
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    const result = String(routeParams.get('result'));
    this.email = routeParams.get('email');

    switch (result) {
      case 'success':
        this.success = true;
        break;
      case 'account-not-found':
        this.failureReason = 'account-not-found';
        break;
      case 'token-expired':
        this.failureReason = 'expired';
        break;
      case 'token-used':
        this.failureReason = 'used';
        break;
      case 'token-invalid':
      default:
        this.failureReason = 'invalid';
        break;
    }

    this.strapi
      .getDocumentsByType('verified-email-page', { populate: '*' })
      .subscribe((data: IStrapiDocument<VerifiedEmailPage>) => {
        this.parsePageData(data.data.attributes);
        super.setMetas();
        this.cdr.detectChanges();
      });
  }

  protected override parsePageData(page: VerifiedEmailPage): void {
    super.parsePageData(page);
    this.pageData = page;
  }

  public resendEmail(e: Event) {
    e.preventDefault();
    if (this.email)
      this.user.resendUnauthenticatedVerificationEmail(this.email).subscribe({
        next: () => {
          this.resent = true;
        },
        error: (err: ApiError) => {
          this.resendError = true;
          if (err.status === 404) {
            this.notFoundError = true;
          }
        },
      });
  }
}
